import { BehaviorSubject } from 'rxjs';
import Cookie from 'js-cookie';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import { useLayoutEffect } from 'react';

//import { handleResponse } from '@/_helpers';

const currentUserSubject = new BehaviorSubject(Cookie.get('currentUser'));
const user = null;

export const AuthService = {
  user,
  login,
  logout,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  },
};

function login(code) {
  /*const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    return fetch(`${config.apiUrl}/users/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
            currentUserSubject.next(user);

            return user;
        });*/
  // ApiGateWay.paramsPost('http://20.184.14.251:8080/StoreInfo-1.0/api/userInfo')
}

function logout() {
  // remove user from local storage to log user out
  Cookie.remove('currentUser');
  Cookie.remove('stores');
  localStorage.removeItem('Login');
}
